import React, { useEffect, useState } from 'react'
import Title from '../../components/common/Title';
import { Topbar } from '../../components/include/Topbar';
import Academic from '../../components/Education/Academic';
import Performance from '../../components/Education/Performance';
import { useLocation, useNavigate } from 'react-router-dom';
import Subject from '../../components/Education/Subject';
import Stream from '../../components/Education/Stream';
import Project from '../../components/Education/Project';
import Facilities from '../../components/Education/Facilities';
import { isPermission, isRole } from '../../redux/selectors/authSelector';
import { useSelector } from 'react-redux';
import Error403Page from '../ErrorPage';

const EducationMain = () => {
    const [activeTab, setActiveTab] = useState("Academics");
    const location = useLocation();
    const tabs = ["Academics", "Performance", "Subjects", "Facilities", "Streams", "Projects"];
    const navigate = useNavigate();
    const permissions = useSelector(isPermission);
    const role = useSelector(isRole)
    console.log("permissions", permissions)
    const isAccessible = role == "schooladmin" || permissions && permissions?.includes('view_Education') || false;
    const addPermission = role == "schooladmin" || permissions && permissions?.includes('edit_Education') || false;


    const handleAddButtonClick = () => {
        if (activeTab === "Performance") {
            navigate("/education/performance/add");
        } else if (activeTab === "Subjects") {
            navigate("/education/subject/add");
        } else if (activeTab === "Facilities") {
            navigate("/education/facilities/add");
        } else if (activeTab === "Streams") {
            navigate("/education/streams/add");
        } else if (activeTab === "Projects") {
            navigate("/education/projects/add");
        }
    };

    const getAddButtonLabel = () => {
        switch (activeTab) {
            case "Performance":
                return "+ Add Performance";
            case "Subjects":
                return "+ Add Subject";
            case "Facilities":
                return "+ Add Facility";
            case "Streams":
                return "+ Add Streams";
            case "Projects":
                return "+ Add Projects";
            default:
                return null;
        }
    };

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };
    useEffect(() => {

        if (location.state?.currentTab) {
            setActiveTab(location.state.currentTab);
        }
    }, [location.state?.currentTab]);


    if (!isAccessible) {
        return (
            <>
                <Error403Page/>
            </>
        );
    }
    return (
        <>

            <Title name="Education" />
            <Topbar title="Education" />
            <div className="p-6 space-y-6 pr-0">
                {/* Tabs */}
                <div className="flex justify-between flex-wrap gap-y-2">
                    <div className="flex gap-2 overflow-x-auto">
                        {tabs?.map((tab) => (
                            <button
                                key={tab}
                                className={`px-4 py-2 rounded-lg whitespace-nowrap ${activeTab === tab
                                    ? "bg-secondary_main text-white"
                                    : "bg-white text-black"
                                    }`}
                                onClick={() => handleTabClick(tab)}
                            >
                                {tab}
                            </button>
                        ))}
                    </div>
                    {activeTab !== "Academics" && (
                        <div className="flex gap-2">
                           {addPermission && <button
                                className="bg-primary_main text-white px-4 py-2 rounded-lg whitespace-nowrap"
                                // onClick={()=> navigate("/education/performance/add")}
                                onClick={handleAddButtonClick}
                            >
                                {getAddButtonLabel()}
                            </button>}

                        </div>
                    )}


                </div>

                {/* Conditional Tab Content */}

                {activeTab === "Academics"  && (
                    <>
                        <Academic />
                    </>
                )}

                {activeTab === "Performance"  && (
                    <>
                        <Performance />
                    </>
                )}

                {activeTab === "Subjects"  && (
                    <>
                        <Subject />

                    </>
                )}

                {activeTab === "Facilities"  && (
                    <>
                        <Facilities />

                    </>
                )}
                {activeTab === "Streams"  && (
                    <>
                        <Stream />
                    </>
                )}
                {activeTab === "Projects" && (
                    <>
                        <Project />

                    </>
                )}
            </div>
        </>
    )
}

export default EducationMain